angular.
module("dx.webapp.node").
controller("DxExternalToolRouteController", function NodeExternalToolsController(
	$rootScope,
	$routeParams,
	$location,
	$timeout,
	$scope,
	$q,

	dxApi,
	dxDialog,
	dxBitFlagsHelper,
	dxLocalize,
	dxSession,
	validationService,
	DX_URLS,
	DX_KEY_CODES,
	DX_URL_ERROR,

	DX_EXTERNAL_TOOL_PERMISSION_TYPE
) {
	"use strict";
	var self = this;

	self.nameMaxLength = 50;

	//Initialize form values
	var initialForm = {};
	self.form = {};
	self.form.organizationId = parseInt($routeParams.orgId, 10);
	var usedInExamTemplateCount = 0;
	self.defaultTitle = dxLocalize.get("ExternalTools.MyTool");
	var initializedLandingPage = "";

	if ($routeParams.id) { //Editing existing tool
		self.isNewTool = false;
		self.form.id = parseInt($routeParams.id, 10);
		dxApi.v1.externalTools.get(self.form.id).then(loadSuccess, loadFail);

		dxApi.v1.externalTools.getUsedInExamTemplateCount(self.form.id).then(function onSuccess(count) {
			usedInExamTemplateCount = count;
		});
	} else {
		self.isNewTool = true;
		self.form.landingPageIsEditable = false;
		self.form.requiredPermissionsIsEditable = false;
		self.form.logo = "PENCIL_RULER";
		copyInitialFormState(self.form);

		self.permissionCamera = false;
		self.permissionMicrophone = false;
		self.permissionScreenShare = false;
	}

	var confirmedLeavingPage = false;
	var nodeToolOverviewURL = DX_URLS.get("nodeView", {id: self.form.organizationId}) + "#external-tools";
	self.allowlistsHelpUrl = dxLocalize.getLanguage() === "sv" ? "https://digiexam.zendesk.com/hc/sv/articles/360017679380" : "https://digiexam.zendesk.com/hc/en-us/articles/360017679380";

	self.onOffAlternatives = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];

	self.allows = {
		domain: {
			input: "",
			urls: [],
		},
		single: {
			input: "",
			urls: [],
		},
		partial: {
			input: "",
			urls: [],
		},
	};

	self.onKeyDown = function onKeyDown(event, allowType) {
		if (event.keyCode === DX_KEY_CODES.enter) {
			event.preventDefault();
			self.addToList(allowType);
		}
	};

	self.addToList = function addToList(allowType) {
		var rawUrl = self.allows[allowType].input;
		if (!rawUrl) {
			return;
		}

		rawUrl = validationService.preprocessUrl(rawUrl);

		if (self.allows[allowType].urls.includes(rawUrl)) {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.URLAlreadyExists"));
			return;
		}

		validationService.isUrlValid(rawUrl, true).then(function onSuccess(resp) {
			if (resp.valid) {
				self.allows[allowType].urls.push(rawUrl);
				self.allows[allowType].input = "";
				$rootScope.$broadcast("notification:success", dxLocalize.get("ExternalTools.SuccessfullyAddedUrl", rawUrl));
			} else {
				switch (resp.error) {
					case DX_URL_ERROR.INVALID_FORMAT:
						$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.InvalidURLFormat"));
						break;
					case DX_URL_ERROR.NO_SUCH_HOST:
						$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.URLCouldNotBeReached"));
						break;
					default:
						$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.InvalidURL"));
				}
			}
		}, function onFail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("SomethingWentWrong"));
		});
	};

	self.removeFromList = function removeFromList(index, allowType) {
		self.allows[allowType].urls.splice(index, 1);
	};

	self.goBack = function goBack() {
		$location.url(nodeToolOverviewURL);
	};

	self.setIcon = function setIcon(newId) {
		self.form.logo = newId;
	};

	self.openIconPicker = function openIconPicker() {
		var dialogScope = $rootScope.$new();
		dialogScope.toolIcon = self.form.logo;
		dialogScope.toolName = self.form.title || self.defaultTitle;
		dialogScope.setIcon = self.setIcon;
		dxDialog.show({
			templateUrl: "tmpl/external-tool/icon-picker/icon-picker.html",
			$scope: dialogScope,
		});
	};

	self.submit = function submit() {
		formIsValid().then(function onSuccess(isFormValid) {
			if (isFormValid) {
				setPermissions();
				setAllowLists();
				if (self.isNewTool) {
					dxApi.v1.externalTools.post(self.form).then(success, fail);
				} else {
					dxApi.v1.externalTools.put(self.form.id, self.form).then(success, fail);
				}
			}
		});

		function success() {
			var message = self.isNewTool ? "ExternalTools.SuccessfullyAddedInfo" : "ExternalTools.SuccessfullySavedInfo";
			$rootScope.$broadcast("notification:success", dxLocalize.get(message));
			confirmedLeavingPage = true;
			$timeout(function onTimeout() {
				$location.url(nodeToolOverviewURL);
			}, 500);
		}

		function fail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotSaveError"));
		}
	};

	self.onDeleteBtnClick = function onDeleteBtnClick() {
		showDeleteConfirmationDialog();
	};

	function setPermissions() {
		var permissions = 0;
		if (self.permissionMicrophone) {
			permissions = dxBitFlagsHelper.addBit(permissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.MICROPHONE);
		}
		if (self.permissionCamera) {
			permissions = dxBitFlagsHelper.addBit(permissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.CAMERA);
		}
		if (self.permissionScreenShare) {
			permissions = dxBitFlagsHelper.addBit(permissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.SCREENSHARE);
		}
		self.form.requiredPermissions = permissions;
	}

	function setAllowLists() {
		self.form.domainUrls = angular.copy(self.allows.domain.urls);
		self.form.singlePageUrls = angular.copy(self.allows.single.urls);
		self.form.partialDomainAccessUrls = angular.copy(self.allows.partial.urls);
	}

	function formIsValid() {
		var deferred = $q.defer();
		if (!self.form.title) {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.EnterNameError"));
			deferred.resolve(false);
		}

		if (self.form.title.length > self.nameMaxLength) {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.NameTooLongError", self.nameMaxLength));
			deferred.resolve(false);
		}

		if (!validationService.isExternalToolTitleValid(self.form.title)) {
			deferred.resolve(false);
		}

		if (!self.form.landingPageIsEditable && !self.form.landingPageUrl) {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.EnterLandingPageError"));
			deferred.resolve(false);
		}

		if (self.form.landingPageUrl) {
			self.form.landingPageUrl = validationService.preprocessUrl(self.form.landingPageUrl);
			validationService.isUrlValid(self.form.landingPageUrl, true).then(function onSuccess(resp) {
				if (!resp.valid) {
					landingPageError(resp.error);
				}
				deferred.resolve(resp.valid);
			}, function onFail() {
				$rootScope.$broadcast("notification:error", dxLocalize.get("SomethingWentWrong"));
				deferred.reject();
			});
		} else {
			deferred.resolve(true);
		}

		return deferred.promise;
	}


	function loadSuccess(response) {
		copyInitialFormState(response.data);
		parseExternalTool(response.data);
	}
	function loadFail() {
		$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotLoadError"));
		$location.url(DX_URLS.get("nodeView", {id: self.form.organizationId}) + "#external-tools");
	}

	function parseExternalTool(data) {
		self.form.title = data.title;
		self.form.description = data.description;
		self.form.logo = data.logo;
		self.form.landingPageUrl = data.landingPageUrl;
		initializedLandingPage = data.landingPageUrl;
		self.form.landingPageIsEditable = data.landingPageIsEditable;
		self.form.requiredPermissionsIsEditable = data.requiredPermissionsIsEditable;

		if (data.domainUrls) {
			self.allows.domain.urls = angular.copy(data.domainUrls);
		}

		if (data.singlePageUrls) {
			self.allows.single.urls = angular.copy(data.singlePageUrls);
		}

		if (data.partialDomainAccessUrls) {
			self.allows.partial.urls = angular.copy(data.partialDomainAccessUrls);
		}

		self.permissionMicrophone = dxBitFlagsHelper.isBitIncluded(
			data.requiredPermissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.MICROPHONE);
		self.permissionCamera = dxBitFlagsHelper.isBitIncluded(
			data.requiredPermissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.CAMERA);
		self.permissionScreenShare = dxBitFlagsHelper.isBitIncluded(
			data.requiredPermissions, DX_EXTERNAL_TOOL_PERMISSION_TYPE.SCREENSHARE);
	}

	function copyInitialFormState(data) {
		initialForm = angular.copy(data);
		initialForm.domainUrls = initialForm.domainUrls || [];
		initialForm.singlePageUrls = initialForm.singlePageUrls || [];
		initialForm.partialDomainAccessUrls = initialForm.partialDomainAccessUrls || [];
		initialForm.requiredPermissions = initialForm.requiredPermissions || 0;
	}

	function showConfirmationDialog(redirectURL) {
		dxDialog.confirm({
			actionIsDangerous: true,
			title: dxLocalize.get("LeaveWarning.Title"),
			body: dxLocalize.get("LeaveWarning.Body"),
			acceptText: dxLocalize.get("Ok"),
			acceptCallback: function accept() {
				confirmedLeavingPage = true;
				dxDialog.closeMostRecent();
				$location.url(redirectURL);
			},
			rejectText: dxLocalize.get("Cancel"),
		});
	}

	function showDeleteConfirmationDialog() {
		var bodyMsg = usedInExamTemplateCount > 0 ?
			dxLocalize.get("ExternalTools.DeleteWarning.Body.UsedInTemplates", usedInExamTemplateCount) :
			dxLocalize.get("ExternalTools.DeleteWarning.Body.NotUsedInTemplates");
		dxDialog.confirm({
			actionIsDangerous: true,
			title: dxLocalize.get("ExternalTools.DeleteWarning.Title", initialForm.title),
			body: bodyMsg,
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: function accept() {
				dxDialog.closeMostRecent();
				deleteExternalTool(initialForm.id, initialForm.title);
			},
			rejectText: dxLocalize.get("No"),
		});
	}

	function deleteExternalTool(toolId, toolName) {
		dxApi.v1.externalTools.delete(toolId).then(function onSuccess() {
			$rootScope.$broadcast("notification:success", dxLocalize.get("ExternalTools.SuccessfullyDeletedInfo", toolName));
			confirmedLeavingPage = true;
			$timeout(function onTimeout() {
				$location.url(nodeToolOverviewURL);
			}, 500);
		}, function onReject() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotDeleteError", toolName));
		});
	}

	function landingPageError(error) {
		switch (error) {
			case DX_URL_ERROR.INVALID_FORMAT:
				$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.InvalidLandingPageFormat"));
				break;
			case DX_URL_ERROR.NO_SUCH_HOST:
				$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.LandingPageCouldNotBeReached"));
				break;
			default:
				$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.InvalidLandingPage"));
		}
	}

	$scope.$watch("vm.form.landingPageUrl", function onLandingPageUrlUpdate(newVal, oldVal) {
		var newLandingPageUrl = validationService.preprocessUrl(newVal);
		var prevLandingPageUrl = validationService.preprocessUrl(oldVal);

		if (newLandingPageUrl === prevLandingPageUrl || !newLandingPageUrl) {
			return;
		}

		validationService.isUrlValid(newLandingPageUrl, true).then(function onSuccess(resp) {
			if (!resp.valid) {
				landingPageError(resp.error);
			}

			if (resp.valid && newVal !== initializedLandingPage) {
				initializedLandingPage = "";
				$rootScope.$broadcast("notification:success", dxLocalize.get("ExternalTools.SuccessfullyAddedLandingPageUrl", newLandingPageUrl));
			}
		}, function onFail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("SomethingWentWrong"));
		});

		self.form.landingPageUrl = newLandingPageUrl;
	});

	$scope.$on("$locationChangeStart", function onLocationChangeStart(event) {
		setPermissions();
		setAllowLists();

		// If the user hasn't already confirmed leaving or saved
		// and the external tool data were edited and the user hasn't logged out
		if (!confirmedLeavingPage &&
			!angular.equals(initialForm, self.form) &&
			dxSession.isAuthenticated()) {
			event.preventDefault();
			showConfirmationDialog($location.url());
		}
	});
});
